/* eslint-disable jsx-a11y/alt-text */
import { Menu } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import moment from "moment/moment";
import { useMemo } from "react";
import { withTranslation } from "react-i18next";
import userLogo from "../../assets/jobSeeker.png";
import { backendUrl } from "../../constants";
import "./styles.css";

const Index = ({ data, key, setReload }) => {
  let user = JSON.parse(localStorage.getItem("userData"));

  //posting date modification
  const modifiedDate = useMemo(() => {
    let today = new moment(new Date()).format("DD MMM YYYY");
    let date = new moment(data?.date).format("DD MMM YYYY");
    if (today === date) {
      return "Today, " + new moment(data?.date).format("HH:MM a");
    } else {
      return date;
    }
  }, [data?.date]);

  const handleDeletePost = () => {
    const options = {
      method: "GET",
    };
    fetch(`${backendUrl}user/deleteStatusUpdate/${data.value}`, options)
      .then((response) => response.json())
      .then((response) => {
        showNotification({
          message: "Post deleted",
          color: "green",
        });
        setReload((v) => !v);
      })
      .catch((err) => console.error(err));
  };

  return (
    <div
      className="d-flex p-3 flex-column shadow mb-3 post-feed"
      key={data.key}
    >
      <div className="profile-in">
        <img
          src={data?.logo || user.logo || userLogo}
          width="50px"
          height="50px"
          className="rounded-circle"
          style={{ border: "1px solid rgb(0,0,0,0.2)", padding: "2px" }}
        />
        <div className="name-info">
          <h6 className="text-info mt-2 mb-0">{data?.name || "You"} </h6>
          <p
            style={{ fontSize: "12px", margin: "0px", color: "rgb(0,0,0,0.5)" }}
          >
            {modifiedDate}
          </p>
        </div>
        {data.userId === user.id && (
          <Menu shadow="md" width={200} className="three-dots">
            <Menu.Target>
              <p className="three-dot-target rounded-circle">...</p>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item onClick={handleDeletePost}>Delete</Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}
      </div>
      <p className="desc-post">{data?.description}</p>
    </div>
  );
};
export default withTranslation()(Index);
